<template>
  <div class="login_contaner">
    <!-- 返回 -->
    <img class="back-gobtn" src="../../assets/images/guide_icon_back.png" @click="backGoBtn" />
    <img class="login_top" src="../../assets/images/guide_icon_top.png" alt />
    <div class="login_main">
      <div class="login_main_item">
        <input type="text" @input="verifyTel" maxlength="11" v-model="tel" placeholder="11位大陆手机号" />
      </div>
      <div class="login_main_item">
        <input type="text" maxlength="6" v-model="code" placeholder="短信验证码" />
        <span v-if="reget" @click="verifyCodeEvent" class="item_icon green">获取验证码</span>
        <span v-if="!reget" class="item_icon grey">{{time}}秒</span>
      </div>
      <div class="login_main_item">
        <div id="SlidingVerification" ref="SlidingVerification">
          <!--      <img
            class="sv-btn"
            ref="svbtn"
            @touchstart="gotouchstart"
            @touchmove="gotouchmove"
            @touchend="gotouchend"
            @mousedown="btnDragStart"
            src="../../assets/images/guide_icon_slider.png"
          />-->

          <!--  @touchmove="gotouchmove" -->
          <div class="sv-btn" ref="svbtn" @touchstart="gotouchstart" @touchend="gotouchend" @mousedown="btnDragStart" :style="{backgroundImage:'url(' + guideIconSlider + ')'}"></div>
          <p class="sv-text" ref="svtext">
            拖动滑块登录
            <span class="nexticon"></span>
          </p>
          <div ref="svbg" class="sv-bg"></div>
        </div>
      </div>
      <div class="text_grey">未注册的手机验证后自动创建鲜枇杷账户</div>
      <img class="login_guide" src="../../assets/images/guide_icon_pic.png" alt />
      <div class="login_agree">
        <span class="agree_grey">登录代表你已同意</span>
        <!--  <span class="agree_green" data-target="conText" @click="showModals">鲜枇杷名片用户协议、隐私政策</span> -->
        <a class="agree_green" data-target="conText" href="https://api.xianpipa.com/%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.html
">鲜枇杷名片用户协议、隐私政策</a>
      </div>
      <div class="login_logo">
        <img src="../../assets/images/guide_icon_logo.png" alt />
        <span>鲜枇杷名片出品</span>
      </div>
    </div>
    <!-- 模态框 -->
    <div class="cu-modal" :class="modalName=='conText'?'show':''">
      <div class="cu-dialog compons-modals">
        <img style="width:100%;" src="../../assets/images/guide_icon_tc.png" alt />
        <img src="../../assets/images/guide_icon_bk.png" class="cu-avatar componts-close-btn" @click="hideModel" />
        <div class="inner-compons-modals">
          <div class="compons-modals-content">隐私条款

            本应用(以下代指鲜枇杷名片APP)非常重视用户的隐私保护，因此制定了本涵盖如何收集、使用、披露、分享以及存储用户的信息的《隐私条款》。用户在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私条款》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私条款》适用于用户与本应用的交互行为以及用户注册和使用本应用的服务，我们建议您仔细地阅读本政策，以帮助您了解维护自己隐私权的方式。

            您使用或继续使用我们的服务，即表示您同意我们按照本《隐私条款》收集、使用、储存和分享您的相关信息。如对本《隐私条款》或相关事宜有任何问题，请进行留言。

            一、我们可能收集的信息

            我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。

            （一）您提供的信息

            1、您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、身份证明、电子邮件等；

            2、如您使用我们的服务需与用户的银行账户或其他支付工具的账户关联方能实现时，您向我们提供您的银行账户信息或其他支付工具的账户信息；

            3、您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。

            （二）其他方分享的您的信息

            其他方使用我们的服务时所提供有关您的共享信息。

            （三）我们获取的您的信息

            1、您使用服务时我们可能收集如下信息：

            （1）日志信息，指您使用我们的服务时，系统自动采集的技术信息，包括：

            o 设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；

            o 在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；

            o 有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；

            o 您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；

            o 您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。

            （2）位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：

            o 您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；

            o 您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；

            o 您可以通过关闭定位功能，停止对您的地理位置信息的收集。

            二、我们如何使用您的信息

            （一）我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：

            1、向您提供服务。在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；

            2、帮助我们设计新服务，改善我们现有服务；

            3、使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；

            4、向您提供与您更加相关的广告以替代普遍投放的广告；

            5、评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；

            6、软件认证或管理软件升级；

            7、让您参与有关我们产品和服务的调查。

            （二）为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。

            三、您如何访问和控制自己的个人信息

            我们将尽量采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。

            四、我们如何分享您的信息

            除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：

            （一）我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：

            o 向您提供我们的服务；

            o 实现“我们可能如何使用信息”部分所述目的；

            o 履行我们在本《隐私条款》或本应用与您达成的其他协议中的义务和行使我们的权利；

            o 理解、维护和改善我们的服务。

            如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私条款》及我们要求其遵守的其他适当的保密和安全措施。

            （二）随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。

            （三）我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：

            o 您授权或同意本应用披露的；

            o 遵守适用的法律法规；

            o 遵守法院命令或其他法律程序的规定；

            o 遵守相关政府机关的要求；

            o 为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途；

            o 根据本应用各服务条款及声明中的相关规定，或者本应用认为必要的其他情形下。

            用户协议

            （以下简称“本公司”）按照下列条款与条件提供信息和产品，您在本协议中亦可被称为“用户”，以下所述条款和条件将构成您与本公司，就您使用提供的内容所达成的全部协议（以下称“本协议”）。

            说明

            本公司向您提供包括但不限于应用下载、使用、充值、客户服务、游戏资讯、论坛交流等服务（以下称“本服务”）。本公司针对本服务所制定的相关规定，包括但不限于本公司在应用平台下运营的任何一款应用所包含的应用规则、用户处罚条例，客服条例等，以及本公司就账号使用及管理、应用充值等服务制定的相关服务协议、规则。本公司在此提示用户，请您在使用本服务前详细阅读本协议的所有内容，尤其是免除、限制本公司责任或者限制用户权利的条款（特别是粗体下划线标注的内容），如您对本协议有任何疑问，请向本公司（0592-3803111）进行咨询。一旦您使用本服务，即表示您已阅读并完全同意接受本协议项下所述条款和条件的约束。如果您不同意本协议的任何条款，请您不要使用本服务。未成年人应经其监护人陪同阅读本服务协议并表示同意，方可接受本服务协议。监护人应加强对未成年人的监督和保护，因其未谨慎履行监护责任而损害未成年人利益或者本公司利益的，应由监护人承担责任。

            权利声明

            1、本公司及其关联公司（关联企业指与本公司存在直接或间接，股权或以协议安排等其他形式的控制与被控制关系，以及对公司运营具有重大影响关系的公司法人）享有并保留以下各项内容完整的、不可分割的所有权及/或知识产权：

            （1）应用平台相关的软件、技术、程序、代码、用户界面等；

            （2）本服务相关的商标、图形标记。

            2、本公司提供的服务内容中所涉及的游戏，文字、软件、声音、图片、动画、录像、图表等，均受相关知识产权法以及其他相关法律的保护。未经本公司或者其他相关权利人授权，用户不得复制、使用、修改、摘编、翻译、发行,第三方未经本公司及/或其相关权利人的书面许可，不得以任何方式擅自进行使用。

            责任限制

            1、本公司向用户提供的服务均是在依"现状"提供，本公司在此明确声明对本服务不作任何明示或暗示的保证，包括但不限于对服务的可适用性、准确性、及时性、可持续性等。

            2、用户理解并同意自行承担使用本服务的风险，且用户在使用本服务时，应遵循中国法律的相关规定，由于用户行为所造成的任何损害和后果，本公司均不承担除法律有明确规定外的责任。

            3、不论在何种情况下，本公司均不对由于网络连接故障、通讯线路、第三方网站、电脑硬件等任何原因给用户造成的任何损失承担除法律有明确规定外的责任。

            用户行为规范

            1、用户在本网站注册时，不得使用虚假身份信息。用户应当妥善保存其账户信息和密码，由于用户泄密所导致的损失需由用户自行承担。如用户发现他人冒用或盗用其账户或密码，或其账户存在其他未经合法授权使用之情形，应立即以有效方式通知本公司。用户理解并同意本公司有权根据用户的通知、请求或依据判断，采取相应的行动或措施，包括但不限于冻结账户、限制账户功能等，本公司对采取上述行动所导致的损失不承担除法律有明确规定外的责任。

            2、用户在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，包括但不限于：

            （1）发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；

            （2）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；

            （3）恶意虚构事实、隐瞒真相以误导、欺骗他人；

            （4）发布、传送、传播广告信息及垃圾信息；

            （5）其他法律法规禁止的行为。

            3、用户不得利用本服务进行任何有损本公司及其关联企业之权利、利益及商誉，或其他用户合法权利之行为。

            4、用户不得基于本服务从事制作、使用、传播“私服”、“外挂”等侵害本公司合法权益的行为。如有违反，本公司将依据中国现行法律法规及本公司的相关规定予以处理。

            5、虚拟财产转移服务外，用户不得通过任何方式直接或变相进行游戏账号、游戏币、游戏道具等虚拟财产的转移。

            6、用户不得从事作弊等损害游戏公平性的行为。用户承诺接受本公司对其游戏数据进行分析，当本公司发现其数据异常时，本公司可根据自己的独立判断认定其为作弊。

            7、用户不得从事任何利用本公司平台系统漏洞进行有损其他用户、本公司或互联网安全的行为。

            8、用户知悉并确认，本公司通过公告、邮件、短信、账户通知以及用户在账户中登记的即时通讯工具等方式，向用户发出关于本服务的通知、规则、提示等信息，均为有效通知。该等信息一经公布或发布，即视为已送达至用户。

            广告信息和促销

            1、用户同意接受本公司通过公告、邮件、短信、账户通知以及用户在账户中登记的即时通讯工具等方式发送的有关本服务，或本公司、本公司之关联企业或与本公司有合作关系的第三方相关的商品、服务促销或其他商业信息。

            2、本公司在本服务中可能提供与其他互联网之网站站点或资源的链接，本公司对存在或源于此类网站站点或资源的任何内容、广告、产品或其他资料不予保证或负责；如该链接所载的内容或搜索引擎所提供之链接的内容侵犯用户权利，本公司声明与上述内容无关，且不承担除法律有明确规定外的责任。</div>
        </div>
        <button class="cu-btn" @click="hideModel">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Notify } from "vant";
import { mapState } from "vuex";
import md5 from "js-md5";
Vue.prototype.$md5 = md5;
import { getlogin, getsendsms } from "../../api/api";
import axios from "axios";

Vue.use(Notify);
let regStr = /^0?(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
export default {
  data () {
    return {
      _sv_flag: false, //默认值验证未成功
      downX: 0,
      tel: "",
      code: "",
      time: 60,
      reget: true, //倒计时为false
      modalName: "",
      svbtnLeft: 0, //缓存滑动块的距离
      svbgWidth: 0, //设置背景的宽度
      guideIconSlider: require("../../assets/images/guide_icon_slider.png"),
      isCodeClick: false
    };
  },
  computed: {
    ...mapState(["baseAPI"])
  },
  created () {
    document.title = "用户登录";
    window.scrollTo(0, 0);
    let that = this;
    if (localStorage.getItem("AUTH_TOKEN")) {
      that.$router.push({
        name: "mindex"
      });
    }
  },
  mounted () {
    var that = this;
    this.svbtnLeft = this.$refs.svbtn.offsetLeft;
    this.svbgWidth = this.$refs.svbg.offsetWidth;
    this.$refs.SlidingVerification.children[0].addEventListener(
      "touchmove",
      function (event) {
        event.preventDefault();
        that.gotouchmove(event);
      },
      false
    );
  },
  methods: {
    backGoBtn: function () {
      this.$router.go(-1);
    },
    showModals: function (e) {
      let mtype = e.currentTarget.dataset.target;
      this.modalName = mtype;
    },
    hideModel: function () {
      this.modalName = "";
    },
    verifyTel: function () {
      var tel = this.tel;

      if (tel.length == 11) {
        if (!regStr.test(this.tel)) {
          Notify({ type: "danger", message: "手机号格式错误，请重新填写" });
        }
      }
    },
    //倒计时函数
    reciprocalCode: function () {
      this.reget = false;
      var that = this;
      var currentTime = that.time;
      var interval = setInterval(function () {
        currentTime--;
        that.time = currentTime;
        if (currentTime <= 0) {
          clearInterval(interval);
          that.time = 60;
          that.reget = true;
          that.isCodeClick = false;
        }
      }, 1000);
    },
    //获取验证码
    verifyCodeEvent: function () {
      if (!this.isCodeClick) {
        var that = this;
        that.isCodeClick = true;
        let tel = this.tel;
        if (!tel) {
          Notify({ type: "danger", message: "请先输入手机号" });
          return;
        }
        var now = new Date();
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth() + 1; //得到月份
        var date = now.getDate(); //得到日期
        var hour = now.getHours(); //得到小时
        var minu = now.getMinutes(); //得到分钟
        var s = now.getSeconds();
        let time =
          year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + s;

        let mobile_account = tel;
        let k = this.$md5(tel + time + "&*)R^r(j%3)");
        let t = this.$md5(tel + k + "&*)R^r(j%3)");

        var formData = new FormData();
        formData.append("mobile_account", mobile_account);
        formData.append("k", k);
        formData.append("t", t);

        let baseURL = that.baseAPI;
        axios.defaults.headers.common["PLATFORM"] = "H5";
        axios.defaults.timeout = 30000;
        //上传
        const instance = axios.create({
          withCredentials: false
        });
        instance
          .post(baseURL + "/v1/users/sendsms", formData)
          .then(res => {
            if (res.data.code == 200) {
              that.reciprocalCode();
            } else {
              Notify({
                message: "获取短信失败",
                color: "#fff",
                background: "#ffbd0a"
              });
              that.isCodeClick = false;
            }
          })
          .catch(function (error) {
            Notify({
              message: error.message,
              color: "#fff",
              background: "#ffbd0a"
            });
            that.isCodeClick = false;
          });
      }
    },
    gotouchstart: function (event) {
      var downX = event.touches[0].clientX;
      this.downX = downX;
    },
    btnDragStart: function (event) {
      let that = this;
      this.downX = event.clientX;
      document.onmousemove = function (ev) {
        that.gotouchmove(ev);
        document.onmouseup = function (ev) {
          that.gotouchend(ev);
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
    },

    gotouchmove: function (event) {
      //阻止左右翻页
      var xStart, xEnd, yStart, yEnd;

      document.addEventListener(
        "touchstart",
        function (evt) {
          xStart = evt.touches[0].pageX;
          yStart = evt.touches[0].pageY;
        },
        false
      );

      document.addEventListener(
        "touchmove",
        function (evt) {
          xEnd = evt.touches[0].pageX;
          yEnd = evt.touches[0].pageY;
          //左右滑动
          if (Math.abs(xStart - xEnd) > Math.abs(yStart - yEnd)) {
            evt.preventDefault();
          }
        },
        false
      );
      var y;
      if (!event.touches) {
        //兼容移动端
        y = event.clientX;
      } else {
        //兼容PC端
        y = event.touches[0].pageX;
      }
      var moveX = y - this.downX;
      var svbtn = this.$refs.svbtn;
      var svbg = this.$refs.svbg;
      var _sv_box = this.$refs.SlidingVerification;
      var _sv_text = this.$refs.svtext;
      //最小的移动范围
      if (svbg.offsetWidth < _sv_box.offsetWidth) {
        if (moveX > 0) {
          svbtn.style.left = moveX + this.svbtnLeft + "px"; //设置滑动块的距离
          svbg.style.width = moveX + svbtn.offsetWidth + "px"; //设置背景的宽度

          if (moveX > _sv_box.offsetWidth - svbtn.offsetWidth) {
            svbtn.style.left = _sv_box.offsetWidth - svbtn.offsetWidth + "px"; //设置滑动块的距离
            svbg.style.width = _sv_box.offsetWidth + "px"; //设置背景的宽度
          }

          //最大的移动范围
          if (moveX >= _sv_box.offsetWidth - svbtn.offsetWidth) {
            //验证成功
            this._sv_flag = true;
          }
        }
      }
    },
    gotouchend: function (event) {
      var that = this;
      var svbtn = this.$refs.svbtn;
      var svbg = this.$refs.svbg;
      var _sv_text = this.$refs.svtext;
      //判断验证是否成功
      if (this._sv_flag) {
        this._sv_flag = false;
        let tel = this.tel;
        let code = this.code;
        if (!tel) {
          Notify({ type: "danger", message: "请输入手机号" });
          svbtn.style.left = this.svbtnLeft + "px"; //设置滑动块的距离
          svbg.style.width = this.svbgWidth + "px"; //设置背景的宽度
          return;
        }
        if (!regStr.test(tel) || tel.length < 11) {
          Notify({ type: "danger", message: "手机号格式错误，请重新填写" });
          svbtn.style.left = this.svbtnLeft + "px"; //设置滑动块的距离
          svbg.style.width = this.svbgWidth + "px"; //设置背景的宽度
          return;
        }
        if (!code) {
          Notify({ type: "danger", message: "请输入验证码" });
          svbtn.style.left = this.svbtnLeft + "px"; //设置滑动块的距离
          svbg.style.width = this.svbgWidth + "px"; //设置背景的宽度
          return;
        }


        var that = this;
        let mobile_account = tel;

        //登录

        var formData = new FormData();

        formData.append("mobile_account", mobile_account);
        formData.append("code", code);

        let baseURL = that.baseAPI;
        axios.defaults.headers.common["PLATFORM"] = "H5";
        axios.defaults.timeout = 30000;
        //上传
        const instance = axios.create({
          withCredentials: false
        });
        instance
          .post(baseURL + "/v1/users/login", formData)
          .then(res => {
            if (res.data.code == 200) {
              //文字提醒
              _sv_text.innerText = "登录成功";
              _sv_text.style.color = "#fff";
              //储存token
              localStorage.setItem("telphone", mobile_account);
              localStorage.setItem("token", res.data.data.token);

              let AUTH_TOKEN = res.data.data.token;
              localStorage.setItem("AUTH_TOKEN", res.data.data.token);
              axios.defaults.headers.common["Authorization"] =
                "Bearer " + AUTH_TOKEN;
              axios.defaults.headers.common["PLATFORM"] = "H5";
              Notify({
                message: "成功登陆",
                color: "#fff",
                background: "#ffbd0a",
                duration: 600
              });

              setTimeout(() => {
                console.log('that.$route.query.redirect',that.$route.query.redirect)
                if (that.$route.query.redirect) {
                  that.$router.push({
                    path: decodeURIComponent(that.$route.query.redirect)
                  });
                } else {
                  that.$router.push({
                    name: "mindex"
                  });
                }
              }, 300);
            } else if (res.data.code == 412) {
              localStorage.removeItem("AUTH_TOKEN");
              localStorage.removeItem("token");
              Notify({
                message: "登陆失败",
                color: "#fff",
                background: "#ffbd0a"
              });
              svbtn.style.left = that.svbtnLeft + "px"; //设置滑动块的距离
              svbg.style.width = that.svbgWidth + "px"; //设置背景的宽度
            }
          })
          .catch(function (err) {
            localStorage.removeItem("AUTH_TOKEN");
            localStorage.removeItem("token");
            svbtn.style.left = that.svbtnLeft + "px"; //设置滑动块的距离
            svbg.style.width = that.svbgWidth + "px"; //设置背景的宽度
            Notify({
              message: err.response.data.message,
              color: "#fff",
              background: "#ffbd0a"
            });
          });
        return;
      } else {
        svbtn.style.left = that.svbtnLeft + "px"; //设置滑动块的距离
        svbg.style.width = that.svbgWidth + "px"; //设置背景的宽度
      }
    }
  }
};
</script>

<style scoped>
.login_contaner {
  overflow-x: hidden;
  background: #fff;
}
.login_top {
  width: 100%;
}
.login_main {
  width: 100%;
  margin-top: 1.240541rem;
  text-align: center;
}
.login_main_item {
  width: 100%;
  height: 2.351351rem;
  position: relative;
  margin-bottom: 0.95405rem;
}
.login_main_item:nth-child(3) {
  margin-bottom: 0.55405rem;
}
.login_main_item input {
  width: 70%;
  height: 1.702703rem;
  margin: 0 auto;
  border-radius: 1.540541rem;
  border: 0;
  background: #f8f7f3;
  font-size: 0.782432rem;
  padding: 0.42432rem 1.205405rem;
}
.item_icon {
  width: 4.802703rem;
  height: 1.20811rem;
  line-height: 1.20811rem;
  margin: 0.7027rem 0;
  position: absolute;
  top: 0;
  right: 11%;
  font-size: 0.782432rem;
  border-left: 0.02702702702702703rem solid #a6d858;
}
.green {
  color: #a6d858;
}
.grey {
  color: #666;
}
* {
  margin: 0;
  padding: 0;
}
#SlidingVerification {
  width: 70%;
  height: 1.702703rem;
  margin: 0 auto;
  border-radius: 1.540541rem;
  background: #f8f7f3;
  padding: 0.42432rem 1.205405rem;
  position: relative;
}
.sv-text {
  position: absolute;
  top: 0;
  left: 0;
  height: 2.351351rem;
  width: 100%;
  text-align: center;
  line-height: 2.351351rem;
  font-size: 0.782432rem;
  color: #ffb307;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nexticon {
  display: inline-block;
  width: 0.3621621rem;
  height: 0.3621621rem;
  content: "";
  border-top: 1px solid #ffb307;
  border-right: 1px solid #ffb307;
  position: relative;
  transform: rotate(45deg);
  margin-left: 0.2221621rem;
}
.nexticon::before {
  display: inline-block;
  width: 0.3621621rem;
  height: 0.3621621rem;
  content: "";
  border-top: 1px solid #ffb307;
  border-right: 1px solid #ffb307;
  position: absolute;
  left: 0.2621621rem;
  bottom: 0.2621621rem;
}
.nexticon::after {
  display: inline-block;
  width: 0.3621621rem;
  height: 0.3621621rem;
  content: "";
  border-top: 1px solid #ffb307;
  border-right: 1px solid #ffb307;
  position: absolute;
  left: 0.5243242rem;
  bottom: 0.5243242rem;
}

.sv-btn {
  width: 2.351351rem;
  height: 2.551351rem;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0.6rem;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  box-shadow: 0 1px 0.13333333rem 0 rgba(255, 179, 7, 0.15);
}
.sv-bg {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 3rem;
  background-color: #fab921;
  border-radius: 1.540541rem;
}
.login_guide {
  width: 70%;
}
.login_agree {
  margin: 0.235135rem 0 0.47027rem;
}
.login_agree .agree_grey {
  font-size: 0.5945945945945946rem;
  color: #999;
}
.login_agree .agree_green {
  font-size: 0.5945945945945946rem;
  color: #88d42d;
  border-bottom: 1px solid #88d42d;
}
.login_logo {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding-bottom: 0.5rem;
}
.login_logo img {
  width: 0.905405rem;
  height: 0.905405rem;
  margin-right: 0.37027rem;
}
.login_logo span {
  margin-top: -0.05405405405405406rem;
  font-size: 0.5405405405405406rem;
  color: #f8b605;
}
.text_grey {
  font-size: 0.6486486486486487rem;
  color: #b7b7b7;
}

/* 模态框 */
.inner-compons-modals {
  width: 100%;
  height: 100%;
}
.componts-close-btn {
  width: 1.3513513513513513rem;
  height: 1.3513513513513513rem;
  position: absolute;
  top: 0.54054rem;
  right: 0.54054rem;
  background-color: transparent;
  z-index: 90;
}
.compons-modals-content {
  width: 90%;
  margin: 0.6rem auto 0;
  height: 13.964865rem;
  font-size: 0.7567567567567568rem;
  line-height: 1.098649rem;
  color: #666666;
  text-align: left;
  overflow: auto;
}
/* ==================
         模态窗口
 ==================== */

.cu-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1110;
  opacity: 0;
  outline: 0;
  text-align: center;
  -ms-transform: scale(1.185);
  transform: scale(1.185);
  backface-visibility: hidden;
  perspective: 2000rpx;
  background: rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease-in-out 0s;
  pointer-events: none;
}

.cu-modal::before {
  content: "\200B";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.cu-modal.show {
  opacity: 1;
  transition-duration: 0.3s;
  -ms-transform: scale(1);
  transform: scale(1);
  overflow-x: hidden;
  overflow-y: auto;
  pointer-events: auto;
}

.cu-dialog {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-left: auto;
  margin-right: auto;
  width: 15.84rem;
  max-width: 100%;
  background-color: #fff;
  border-radius: 0.26rem;
  overflow: hidden;
}

.cu-modal.bottom-modal::before {
  vertical-align: bottom;
}

.cu-modal.bottom-modal .cu-dialog {
  width: 100%;
  border-radius: 0;
}

.cu-modal.bottom-modal {
  margin-bottom: -26.66rem;
}

.cu-modal.bottom-modal.show {
  margin-bottom: 0;
}

.cu-modal.drawer-modal {
  transform: scale(1);
  display: flex;
}

.cu-modal.drawer-modal .cu-dialog {
  height: 100%;
  min-width: 5.33rem;
  border-radius: 0;
  margin: initial;
  transition-duration: 0.3s;
}

.cu-modal.drawer-modal.justify-start .cu-dialog {
  transform: translateX(-100%);
}

.cu-modal.drawer-modal.justify-end .cu-dialog {
  transform: translateX(100%);
}

.cu-modal.drawer-modal.show .cu-dialog {
  transform: translateX(0%);
}
.cu-modal .cu-dialog > .cu-bar:first-child .action {
  min-width: 2.66rem;
  margin-right: 0;
  min-height: 2.66rem;
}

.cu-btn {
  border: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 4.2rem;
  font-size: 0.85rem;
  height: 2.4rem;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  background-image: linear-gradient(-90deg, #f9da5b, #ffbd0a);
  color: #fff;
  border-radius: 1.3513513513513513rem;
  margin: 1.3rem auto 0.8rem;
}
.back-gobtn {
  position: fixed;
  z-index: 50;
  top: 0.875676rem;
  left: 0.875676rem;
  width: 1.5675675675675675rem;
  height: 1.5675675675675675rem;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/login.vue